const options: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    hour12: false,
    minute: '2-digit',
};

/**
 * Formats a value as a `HH:mm` time string.
 *
 * @param value - the date to format
 * @param language - the language to format for, usually `i18n.language`. When
 * omitted the runtime default locale is used, which does not follow the
 * language selected in the app.
 */
const toTime = (value: Date | number, language?: string) =>
    new Intl.DateTimeFormat(language, options).format(value);

export {toTime};
